import React from "react";

// Canonical status chip shared across gateway PLC pages. Only four tones
// exist platform-wide (see plc-fleet-rollouts.js / platform-edge-runtimes.js):
// isPositive | isNeutral | isWarning | isDanger.
const TONE_CLASS = {
  positive: "isPositive",
  neutral: "isNeutral",
  warning: "isWarning",
  danger: "isDanger",
};

export const PlcStatusPill = ({ tone, children, title }) => (
  <span className={`gwStatusPill ${TONE_CLASS[tone] || "isNeutral"}`} title={title}>
    {children}
  </span>
);
